// Body of the password-reset request view: the sealy AccountShell (side nav +
// phone-less content title) wrapping the PasswordResetForm rendered as a
// native React field tree. help_text is server-localized; the submit label and
// title were hardcoded English in the legacy template.
import { Immutable } from "immer";
import React from "react";
import { FormFields } from "tsi-common-react/src/apps/customer-account/FormFields/index";
import {
    FORM_FIELD_SUBMIT_CLASS_NAME,
    FORM_HELP_TEXT_CLASS_NAME,
} from "tsi-common-react/src/forms/classNames";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { AccountShell } from "../AccountShell";

type IProps = Immutable<templates.PasswordResetDocumentTemplate>;

export const PasswordResetBody = (props: IProps): React.JSX.Element => (
    <AccountShell
        hasNav={props.has_nav}
        sideNav={props.side_nav}
        title={props.content_title}
    >
        <p className={FORM_HELP_TEXT_CLASS_NAME}>{props.help_text}</p>
        <div className="my-account-form">
            <form
                id="password_reset_form"
                className="js-kuid-form"
                action={props.action_url}
                method="post"
            >
                <CSRFToken />
                <FormFields
                    fields={props.fields}
                    field_labels={props.field_labels}
                    field_errors={props.field_errors}
                    non_field_errors={props.non_field_errors}
                />
                <div className={FORM_FIELD_SUBMIT_CLASS_NAME}>
                    <input
                        type="submit"
                        className="button button--full-width"
                        value={props.submit_text}
                    />
                </div>
            </form>
        </div>
    </AccountShell>
);
